import { render } from "./myInvitation.vue?vue&type=template&id=ba27648a&scoped=true"
import script from "./myInvitation.vue?vue&type=script&lang=ts"
export * from "./myInvitation.vue?vue&type=script&lang=ts"

import "./myInvitation.vue?vue&type=style&index=0&id=ba27648a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-ba27648a"

export default script